import React from "react";
import {
  Dropdown,
  Option,
} from "../../../components/tailwind/dropdown/Dropdown";

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: Record<string, string>; // value -> label mapping
  disabled?: boolean;
};

export const SingleSelectField: React.FC<Props> = ({
  value,
  onChange,
  options,
  disabled,
}) => {
  // Convert options object to Dropdown format
  const dropdownOptions: Option<string>[] = Object.entries(options).map(
    ([optionValue, optionLabel]) => ({
      key: optionValue,
      value: optionValue,
      text: optionLabel,
    })
  );

  // Ensure value is valid (exists in options), otherwise use null
  const validValue = value && options[value] ? value : null;

  return (
    <div className="tw-w-full">
      <Dropdown
        options={dropdownOptions}
        value={validValue}
        onChange={(selectedValue) => onChange(selectedValue as string)}
        placeholder="Select an option"
        disabled={disabled}
        size="sm"
      />
    </div>
  );
};
